// extracted by mini-css-extract-plugin
export default {"root":"P2aYZnHH"};